import React from 'react';
import { ContentTypeIcon } from '../media-link-dialog-header/content-type-icon.js';
import stylesBreadcrumb from './breadcrumb.module.css.js';

function ContentTypeBreadcrumb({ 'data-testid': dataTestId, contentType: { name, icon, iconClassName }, }) {
    return (React.createElement("span", { "data-testid": dataTestId, className: stylesBreadcrumb.breadcrumb },
        React.createElement(ContentTypeIcon, { name: name, className: stylesBreadcrumb.icon, icon: icon, iconClassName: iconClassName }),
        React.createElement("span", { className: stylesBreadcrumb.text }, name)));
}

export { ContentTypeBreadcrumb };
